const ALLOWED_PROVIDERS = ['local', 'session'];

export const store = (providerName, key) => {
  if (!ALLOWED_PROVIDERS.includes(providerName)) {
    throw new Error(`Unsupported provider`);
  }

  const provider =
    providerName === 'session' ? 'sessionStorage' : 'localStorage';

  function getData() {
    if (!process.browser) {
      return {};
    }

    const value = window[provider].getItem(key);

    if (value === null) {
      return {};
    }

    try {
      return JSON.parse(value);
    } catch (err) {
      return {};
    }
  }

  return {
    getEntry(id, defaultValue = undefined) {
      const data = getData();
      const value = data[id];

      if (value === undefined) {
        return defaultValue;
      }

      return value;
    },

    hasEntry(id) {
      return this.getEntry(id) !== undefined;
    },

    setEntry(id, value) {
      const data = getData();

      data[id] = value;

      window[provider].setItem(key, JSON.stringify(data));
    },

    clear() {
      window[provider].removeItem(key);
    },
  };
};
